import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { PageLevelNotification } from '@americanexpress/dls-react';

const toNotificationType = (type) => (type === 'success' ? 'success' : 'critical');

const ResponseMessages = ({ statusMessage, errorLabel }) => {
  if (statusMessage.message !== '') {
    switch (statusMessage.message) {
      case 'extensionError':
      case 'submitNetworkErrorLabel':
      case 'batchSizeError':
      case 'totalSizeExceedsError':
      case 'uploadApiError':
      case 'sizeExceedsError':
      case 'sizeError': return (

        <div
          tabIndex="0"
          className="width-full flex flex-column pad-1-t"
        >
          <PageLevelNotification
            type={toNotificationType(statusMessage.type)}
            isDismissible={false}
          >
            <span className="response-messages-notification-title">
              <FormattedMessage
                id={statusMessage.message}
                values={{
                  fileSize: statusMessage.fileSize,
                  totalSize: statusMessage.totalSize,
                }}
              />
            </span>
            <div className="margin-1-t response-messages-notification-body">
              {errorLabel && (
                <FormattedMessage
                  id={errorLabel}
                  defaultMessage={errorLabel}
                  values={{
                    br: <br />,
                  }}
                />
              )}
            </div>
          </PageLevelNotification>
        </div>
      );
      default: return (

        <div tabIndex="0" className="flex-justify-center text-align-center pad-1-t">
          <PageLevelNotification className="text" type={toNotificationType(statusMessage.type)} isDismissible={false}>
            <FormattedMessage id={statusMessage.message} />
          </PageLevelNotification>
        </div>
      );
    }
  }
  return null;
};

ResponseMessages.defaultProps = {
  statusMessage: null,
};

ResponseMessages.propTypes = {
  statusMessage: PropTypes.instanceOf(Object),
  errorLabel: PropTypes.string.isRequired,
};

export default ResponseMessages;
